'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';

const common = {
  init() {
    //Coloca asterisco ao lado dos labels de acordo com o tipo ONLINE/PRESENCIAL.
    $('input[name="type"]').on('change', function () {
      if ($(this).val() == 'online') {
        $('[data-required-online]').addClass('u-required-label');
        $('[data-required-present]').removeClass('u-required-label');
      } else {
        $('[data-required-online]').removeClass('u-required-label');
        $('[data-required-present]').addClass('u-required-label');
      }
    });

    $('.continue').on('click', function (e) {
      e.preventDefault();

      let currentSlide = $(this).attr('data-current');
      let nextSlide = $(this).attr('data-next');

      if (currentSlide == 'compliance') {
        let $checked = $('input[name="agree"]:checked').length;

        if ($checked === 0) {
          Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
          return false;
        }
      }

      if (currentSlide == 'first') {
        let $checked = $('input[name="activities[]"]:checked').length;
        let $pensar = $('#pensar:checked').val();

        if ($pensar == 'PENSAR') {
          nextSlide = 'tabpensar';
        }

        if (
          $("input[name='title']").val() == '' ||
          $("input[name='is_limited']:checked").val() == null ||
          $checked === 0
        ) {
          Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
          return false;
        }
      }

      if (currentSlide == 'tabpensar') {
        let $checked = $('input[name="agree_pensar"]:checked').length;

        if ($checked === 0) {
          Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
          return false;
        }
      }

      if (currentSlide == 'organization') {
        let $type = $('#c-type input[name="type"]:checked').length;

        if (!$('.js-state-filter').val() || !$('.js-cities').val()) {
          Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
          return false;
        }

        if (
          $type === 0 ||
          $('.js-organization option:selected').val() == '' ||
          ($('.js-organization option:selected').val() == '1' && $("input[name='school_name']").val() == '') ||
          ($('.js-organization option:selected').val() == '2' && $("input[name='organization_name']").val() == '') ||
          ($('.js-organization option:selected').val() == '3' && $("input[name='public_name']").val() == '') ||
          ($('.js-organization option:selected').val() == '5' && $("[name='organizationlist_name']").val() == '')
        ) {
          Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
          return false;
        } else if ($("input[name='school_address']").val() == '') {
          Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
          return false;
        }
      }

      if (currentSlide == 'due_date') {
        if ($("input[name='calendar']").val() == '' || $('#time_start_at').val() == '') {
          Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
          return false;
        }
      }

      if (currentSlide == 'materials') {
        if ($('[name="material_name[]"]').length) {
          for (let $i = 0; $i < $('[name="material_name[]"]').length; $i++) {
            let $el = $('[name="material_name[]"]')[$i];
            if (!$el.value.length) {
              Swal.fire('Atenção!', 'Preencha o nome dos materiais', 'error');
              return false;
            }
          }
        }
      }

      if (currentSlide == 'groups') {
        let $checked = $('input[name="has_groups"]:checked');

        if ($checked.val() == 1 && !$('.js-groups').val()) {
          Swal.fire('Atenção!', 'Selecione um grupo para continuar', 'error');
          return false;
        }
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });

      $('.publish-challenge').on('click', function (e) {
        e.preventDefault();
        if ($('#cover_url').val() == '' && $('#customFile').val() == '') {
          Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
          return false;
        }

        $('.form-signin').trigger('submit');
      });

      $('#' + currentSlide).removeClass('active');
      $('#' + nextSlide).addClass('active');
    });

    $('.back').on('click', function (e) {
      e.preventDefault();

      let currentSlide = $(this).attr('data-current');
      let nextSlide = $(this).attr('data-next');

      window.scrollTo({ top: 0, behavior: 'smooth' });

      if (currentSlide == 'organization') {
        let $pensar = $('#pensar:checked').val();

        if ($pensar == 'PENSAR') {
          nextSlide = 'tabpensar';
        }
      }

      $('#' + currentSlide).removeClass('active');
      $('#' + nextSlide).addClass('active');
    });

    $('.js-limited').on('change', function () {
      if ($("input[name='is_limited']:checked").val() == '1') {
        $('#js-vacancies--total').removeClass('u-display--none');
      } else {
        $('#js-vacancies--total').addClass('u-display--none');
      }
    });

    function hideAll() {
      $('#c-school').addClass('u-display--none');
      $('#c-school input[name = "school_name"]').val('');

      $('#c-organization').addClass('u-display--none');
      $('#c-organization input[name = "organization_name"]').val('');

      $('#c-public').addClass('u-display--none');
      $('#c-public input[name = "public_name"]').val('');

      $('#c-organizationlist').addClass('u-display--none');
      $('.js-organizationlist').val('');
    }

    $("#c-type input[name='type']").on('change', () => {
      $('#s-organization').removeClass('u-display--none');
    });

    $('.js-organization').on('change', function () {
      let type = $("input[name='type']:checked").val();

      if (this.value == 0) {
        $('#c-address').addClass('u-display--none');
        $('#c-address input[name = "school_address"]').val('');
      } else if (this.value > 0 && type == 'online') {
        $('#c-address').removeClass('u-display--none');
      } else {
        $('#c-address').removeClass('u-display--none');
      }

      if (this.value == 1) {
        hideAll();
        $('#c-school').removeClass('u-display--none');
      } else if (this.value == 2) {
        hideAll();
        $('#c-organization').removeClass('u-display--none');
      } else if (this.value == 3) {
        hideAll();
        $('#c-public').removeClass('u-display--none');
      } else if (this.value == 5) {
        hideAll();
        $('#c-organizationlist').removeClass('u-display--none');
      } else {
        hideAll();
      }
    });

    var $coverChosen = document.getElementById('cover_chosen');
    var $coverUrl = document.getElementById('cover_url');

    $('.js-thumb').on('click', function () {
      $coverChosen.src = $(this).attr('src');
      $coverUrl.value = $(this).attr('src');
    });
  },
};

const _this = common;

export default _this;
